export { default } from './PromoTag';
